import { Vector } from "./Vector";
import { Time } from "./Time";
import * as Constants from "./Constants";

export class Sun {

    /** Equatorial radius of the Sun in km */
    static readonly RADIUS = 696000;

    /** Gravitational constant times mass in km³/s² */
    static readonly GM = 132712438000;

    //
    // Get rough unit vector of sun in geocentric equatorial coordinates
    // Accuracy better than 1 arc minute.
    //
    static getRoughPos(tt: number): Vector {
        // First compute the time in Julian centuries since J2000
        let T = Time.getCenturiesSinceJ2000(tt);

        let M = (6.240038674 + 628.3019494 * T) % Constants.TWOPI; //Mean longitude of moon (in revs.)
        let DL = 0.033418 * Math.sin(M) + 0.000349 * Math.sin(2 * M);
        let L = (4.93824 + M + DL + 0.030016 * T) % Constants.TWOPI;
        let SineL = Math.sin(L);
        
        return new Vector(Math.cos(L), Math.cos(Constants.OBLIQUITY_2000) * SineL, Math.sin(Constants.OBLIQUITY_2000) * SineL);
    }

}


// WEBPACK FOOTER //
// ./src/Sun.ts